export enum EntitlementPageTabsColumnKeys {
  SUBSCRIPTION = 'subscription',
  STATUS = 'status',
  APPS = 'apps',
  ORG_NAME = 'org-name',
  SITE = 'site',
  USAGE = 'usage',
  BILLING_CYCLE = 'billing-cycle',
  CREATED = 'created',
  ENTITLEMENT_NUMBER = 'entitlement-number',
  PLAN = 'plan',
  QUANTITY = 'quantity',
  RENEW_DATE = 'renew-date',
  LINKED_SUBSCRIPTIONS = 'linked-subscriptions',
}

export enum EntitlementPageTabsColumn {
  ENTERPRISE_INSTANCES = 'enterprise-instances',
  INCLUDED_PRODUCTS = 'included-products',
  INCLUDED_IN = 'included-in',
  INSTALLED_ON = 'installed-on',
}

export interface EntitlementPageTabsColumnConfigurationType {
  columnKey: EntitlementPageTabsColumnKeys;
  columnLabel?: string;
  shouldTruncate?: boolean;
  width: number;
}

interface EntitlementPageTabsConfigurationType {
  [key: string]: EntitlementPageTabsColumnConfigurationType[];
}

export const EntitlementPageTabsColumnConfiguration: EntitlementPageTabsConfigurationType = {
  [EntitlementPageTabsColumn.ENTERPRISE_INSTANCES]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      columnLabel: 'Subscription',
      shouldTruncate: true,
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.APPS,
      columnLabel: 'Apps',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.ORG_NAME,
      columnLabel: 'Org name',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.SITE,
      columnLabel: 'Site',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.USAGE,
      columnLabel: 'Usage',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.BILLING_CYCLE,
      columnLabel: 'Billing cycle',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.CREATED,
      columnLabel: 'Created',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.ENTITLEMENT_NUMBER,
      columnLabel: 'Entitlement number',
      width: 15,
    },
  ],
  [EntitlementPageTabsColumn.INCLUDED_PRODUCTS]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Products',
      width: 20,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.LINKED_SUBSCRIPTIONS,
      columnLabel: 'Linked subscriptions',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.SITE,
      columnLabel: 'Site',
      width: 25,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Next bill date',
      width: 10,
    },
  ],
  [EntitlementPageTabsColumn.INCLUDED_IN]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Products',
      width: 20,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.LINKED_SUBSCRIPTIONS,
      columnLabel: 'Linked subscriptions',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.ORG_NAME,
      columnLabel: 'Org name',
      width: 25,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Next bill date',
      width: 10,
    },
  ],
};

export const EntitlementPageTabsColumnConfigurationV2 = {
  [EntitlementPageTabsColumn.ENTERPRISE_INSTANCES]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Subscription',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.APPS,
      columnLabel: 'Apps',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.SITE,
      columnLabel: 'Site',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Renew date',
      width: 10,
    },
  ],
  [EntitlementPageTabsColumn.INCLUDED_PRODUCTS]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Products',
      width: 20,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.LINKED_SUBSCRIPTIONS,
      columnLabel: 'Linked subscriptions',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.SITE,
      columnLabel: 'Site/Org',
      width: 25,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Next bill date',
      width: 10,
    },
  ],
  [EntitlementPageTabsColumn.INCLUDED_IN]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Products',
      width: 20,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.LINKED_SUBSCRIPTIONS,
      columnLabel: 'Linked subscriptions',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.ORG_NAME,
      columnLabel: 'Site/Org',
      width: 25,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Next bill date',
      width: 10,
    },
  ],
  [EntitlementPageTabsColumn.INSTALLED_ON]: [
    {
      columnKey: EntitlementPageTabsColumnKeys.SUBSCRIPTION,
      shouldTruncate: true,
      columnLabel: 'Products',
      width: 20,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.STATUS,
      columnLabel: 'Status',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.PLAN,
      columnLabel: 'Plan',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.APPS,
      columnLabel: 'Apps',
      width: 15,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.SITE,
      columnLabel: 'Site',
      width: 25,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.QUANTITY,
      columnLabel: 'Quantity',
      width: 10,
    },
    {
      columnKey: EntitlementPageTabsColumnKeys.RENEW_DATE,
      columnLabel: 'Renew date',
      width: 10,
    },
  ],
};
